import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SendAndArchiveIcon(props: IconProps) {
    return <Icon {...props} iconKey={"send_and_archive"}/>
}
